// Script of the coded Market data demo (replaces markkinadatavideo.mp4, which was Finnish only and silent).
// Finnish and English show the Finnish projects of the original video; Swedish shows Swedish municipalities.
// Every project, date and amount below is taken from decisions in Tendera's data (checked 23.10.2026):
// FI from the recorded video's AI answers, SE from Nynäshamn KF 2026-06-11 § 46, Markaryd KF 2025-12-15 § 127,
// UN 2026-01-28 § 10, KS 2026-06-09 § 126 / KF 2026-06-22 § 88, UKN 2026-08-12 § 114, Gnesta BUN 2026-10-01 § 58,
// Malmö KS 2026-08-12 § 294 and Strömsund KS 2026-06-23 § 122. Change them only against the source.

const fiProjects = [
    ['Kiuruvesi', 'Koulukeskuksen rakentaminen', '2 900 000 €'],
    ['Akaa', 'Päiväkotihanke (KVR-urakka)', 'yli 3 000 000 €'],
    ['Hanko (Hangon Vesi)', 'Rakennusohjelma 2026', '1 080 000 €'],
    ['Kiuruvesi', 'Jätevesiviemärit', '170 000 €'],
    ['Petäjävesi', 'Keski-Suomen maailmanperintökeskus', 'ei täsmennetty'],
    ['Iisalmi', 'Hankesuunnitelman laadinta', 'varaus talousarviossa'],
];

const fiTimeline = [
    ['23.9.2024', 'Kaupunginvaltuusto käsittelee hankesuunnittelua: kolme sijaintivaihtoehtoa vertailuun.'],
    ['24.10.2024', 'Rakennushistoriallinen selvitys Nivan koulusta valmistuu.'],
    ['19.11.2024', 'Tekninen lautakunta käsittelee hanketta, asemakaavatyö käynnissä.'],
    ['Kevät 2025', 'Hankesuunnitelman laadinta (UKI Arkkitehdit).'],
    ['10.2.2026', 'Tekninen lautakunta hyväksyy hankesuunnitelman: kaupungin vuoden 2026 suurin investointi.'],
];

const enProjects = [
    ['Kiuruvesi', 'New school centre', '€2,900,000'],
    ['Akaa', 'Day-care centre (design-build)', 'over €3,000,000'],
    ['Hanko (Hanko Water)', 'Construction programme 2026', '€1,080,000'],
    ['Kiuruvesi', 'Wastewater sewers', '€170,000'],
    ['Petäjävesi', 'Central Finland World Heritage Centre', 'not specified'],
    ['Iisalmi', 'Project plan preparation', 'reserved in budget'],
];

const enTimeline = [
    ['23 Sep 2024', 'City council discusses project planning: three site options compared.'],
    ['24 Oct 2024', 'Building history survey of the Niva school completed.'],
    ['19 Nov 2024', 'Technical committee discusses the project; zoning plan work under way.'],
    ['Spring 2025', 'Project plan prepared (UKI Arkkitehdit).'],
    ['10 Feb 2026', 'Technical committee approves the project plan: the town’s largest investment of 2026.'],
];

const svProjects = [
    ['Nynäshamn', 'Sunnerby förskola (konceptförskola)', '46 mnkr'],
    ['Markaryd', 'Ny förskola och F–3-skola i Timsfors', 'i budget 2026'],
    ['Malmö', 'Vård- och omsorgsboende i Hyllie', 'KS 12.8.2026'],
    ['Gnesta', 'Förskola och grundskola i Stjärnhov', 'behovsanalys'],
    ['Strömsund', 'Särskilt boende i Backe', 'projektering'],
];

const svTimeline = [
    ['22.10.2025', 'Behovsanalys för Timsfors skola och förskola. Utredningen visade stora brister i skolbyggnaden.'],
    ['15.12.2025', 'Kommunfullmäktige beslutar att bygga ny förskola och F–3-skola i Timsfors.'],
    ['28.1.2026', 'Utbildningsnämnden informeras om byggnationen; önskemål om fullstor idrottssal.'],
    ['9.6.2026', 'Kommunstyrelsen följer upp projektet; från hösten 2026 finns F–3 kvar i Timsfors skola.'],
    ['12.8.2026', 'Arbetet med skolan i Timsfors pågår enligt plan.'],
];

export const MARKET_DATA_DEMO = {
    fi: {
        pageTitle: 'Markkinadata',
        assistant: 'AI-hakuavustaja',
        tabs: ['Live-chat', 'Aiemmat keskustelut', 'Suodattimet'],
        placeholder: 'Kysy kuntapäätöksistä…',
        emptyHint: 'Kysy mitä vain kuntien ja hyvinvointialueiden päätöksistä.',
        question: 'Listaa merkittävimmät hankesuunnitelmat vuodelle 2026',
        answerTitle: 'Merkittävät hankesuunnitelmat vuodelle 2026',
        answerLead: 'Asiakirjoista löytyy useita merkittäviä hankkeita eri kunnista. Suurimmat ovat Akaan päiväkoti ja Kiuruveden koulukeskus.',
        columns: ['Kunta', 'Hanke', 'Budjetti'],
        projects: fiProjects,
        signalsTitle: 'Hankesignaalit',
        signals: [
            ['Kiuruvesi', 'Tekninen lautakunta hyväksyi hankesuunnitelman 10.2.2026. Kaupungin vuoden 2026 suurin investointi.'],
            ['Akaa', 'Kilpailutus kiinteistöleasing-mallilla ja KVR-urakkana on suunniteltu käynnistettäväksi.'],
        ],
        followUp: 'Kiuruveden koulukeskus: kerro hankkeen vaiheet',
        timelineTitle: 'Kiuruveden koulukeskus vaiheittain',
        timeline: fiTimeline,
        source: 'pöytäkirja',
        endLines: ['Näe tulevat hankkeet ennen kilpailutusta.', 'Kysy kuntien päätöksistä omin sanoin.', 'Markkinadata kuuluu Pro-pakettiin.'],
        chapters: ['Kysy', 'Hankkeet', 'Jatkokysymys', 'Vaiheet', 'Tendera'],
    },
    en: {
        pageTitle: 'Market data',
        assistant: 'AI search assistant',
        tabs: ['Live chat', 'Earlier chats', 'Filters'],
        placeholder: 'Ask about municipal decisions…',
        emptyHint: 'Ask anything about the decisions of municipalities and wellbeing services counties.',
        question: 'List the most significant project plans for 2026',
        answerTitle: 'Significant project plans for 2026',
        answerLead: 'The documents show several significant projects across municipalities. The largest are the Akaa day-care centre and the Kiuruvesi school centre.',
        columns: ['Municipality', 'Project', 'Budget'],
        projects: enProjects,
        signalsTitle: 'Project signals',
        signals: [
            ['Kiuruvesi', 'The technical committee approved the project plan on 10 Feb 2026. The town’s largest investment of 2026.'],
            ['Akaa', 'Tendering as a property-leasing and design-build contract is planned to start.'],
        ],
        followUp: 'Kiuruvesi school centre: walk me through the stages',
        timelineTitle: 'Kiuruvesi school centre, stage by stage',
        timeline: enTimeline,
        source: 'minutes',
        endLines: ['See upcoming projects before they are tendered.', 'Ask about municipal decisions in your own words.', 'Market data is included in Pro.'],
        chapters: ['Ask', 'Projects', 'Follow-up', 'Stages', 'Tendera'],
    },
    sv: {
        pageTitle: 'Marknadsdata',
        assistant: 'AI-sökassistent',
        tabs: ['Livechatt', 'Tidigare chattar', 'Filter'],
        placeholder: 'Fråga om kommunala beslut…',
        emptyHint: 'Fråga vad som helst om kommuners och regioners beslut.',
        question: 'Lista de viktigaste byggprojekten som planeras 2026',
        answerTitle: 'Planerade byggprojekt 2026',
        answerLead: 'Protokollen visar flera större projekt i olika kommuner, bland dem Sunnerby förskola i Nynäshamn.',
        columns: ['Kommun', 'Projekt', 'Budget'],
        projects: svProjects,
        signalsTitle: 'Projektsignaler',
        signals: [
            ['Nynäshamn', 'Kommunfullmäktige godkände 46 mnkr och uppdrog att detaljprojektera en konceptförskola.'],
            ['Markaryd', 'Fullmäktige beslutade att bygga ny förskola och F–3-skola i Timsfors.'],
        ],
        followUp: 'Timsfors skola: berätta steg för steg',
        timelineTitle: 'Timsfors skola steg för steg',
        timeline: svTimeline,
        source: 'protokoll',
        endLines: ['Se kommande projekt innan de upphandlas.', 'Fråga om kommunala beslut med egna ord.', 'Marknadsdata ingår i Pro.'],
        chapters: ['Fråga', 'Projekt', 'Följdfråga', 'Steg', 'Tendera'],
    },
};

export const marketDataDemoContent = (language) => MARKET_DATA_DEMO[String(language || '').split('-')[0]] || MARKET_DATA_DEMO.en;
